import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCurrent, createVote } from '../../actions/reviews';
import Loader from 'react-loader';
import AddEditModal from './Components/AddEditModal';
import { FaRegStar, FaStar, FaStarHalfStroke } from "react-icons/fa6";
import styles from './styles.module.scss';
import { MdOutlineInsertPhoto } from 'react-icons/md';
import { AiFillDislike, AiFillLike } from "react-icons/ai";
import { Pagination } from '../../assets/Pagination/Pagination';


const renderStars = (score = 0, size = 30) => {
  const full = Math.floor(score);
  const hasHalf = score % 1 !== 0;
  const empty = 5 - full - (hasHalf ? 1 : 0);

  return (
    <>
      {Array.from({ length: full }).map((_, idx) => (
        <FaStar key={`full-${idx}`} size={size} color="#7b2b2a" />
      ))}
      {hasHalf && <FaStarHalfStroke key="half" size={size} color="#7b2b2a" />}
      {Array.from({ length: empty }).map((_, idx) => (
        <FaRegStar key={`empty-${idx}`} size={size} color="#7b2b2a" />
      ))}
    </>
  );
};

const Current = ({ getCurrent, createVote, data, loading, match, isTeacher, pageCount }) => {
  const { id } = match.params;
  const [modal, setModal] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    getCurrent(id, pageNumber);
  }, [id, pageNumber]);

  const openModal = () => {
    const { teacher_fio, teacher_id } = data;
    setModal({ teacher_fio, teacher_id });
  };

  return (
    <div className={styles.currentWrapper}>
      <div className="captions">Оценка качеств преподавателя, составленная на основании отзывов</div>

      <AddEditModal
        isOpen={!!modal}
        onRequestClose={() => setModal(null)}
        data={modal}
        getListCB={() => getCurrent(id, pageNumber)}
        teacherMode
      />

      <Loader loaded={data && !loading} color="grey">
        <div>
          <div>
            <MdOutlineInsertPhoto size={100} color="#7b2b2a" />
          </div>
          <div>
            <h2>{data?.teacher_fio}</h2>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {renderStars(data?.average_score)}
              <span>{data?.average_score}</span>
            </div>
          </div>
        </div>

        {isTeacher && <button className="btn" onClick={openModal}>Добавить отзыв</button>}

        <h5>Отзывы:</h5>

        <Pagination
          pageCount={pageCount}
          onPageChange={({ selected }) => setPageNumber(selected)}
          numberPage={pageNumber}
        />

        <ul className={styles.currentList}>
          {data?.reviews.map((item) => (
            <ReviewItem key={item.review_id} data={item} createVote={createVote} />
          ))}
        </ul>

        <Pagination
          pageCount={pageCount}
          onPageChange={({ selected }) => setPageNumber(selected)}
          numberPage={pageNumber}
        />
      </Loader>
    </div>
  );
};

const ReviewItem = ({ data: initData, createVote }) => {
  const [fullMode, setFullMode] = useState(false);
  const [data, setData] = useState(initData);

  const commentText =
    data.comment.length > 100 && !fullMode
      ? data.comment.slice(0, 100) + '…'
      : data.comment;

  const createVoteHandler = (vote_type) => async () => {
    const response = await createVote({
      review_id: data.review_id,
      vote_type,
    });
    setData((prev) => ({ ...prev, ...response }));
  };

  return (
    <li>
      <div>{data.student_fio || 'Аноним'}</div>
      <div>{renderStars(data.average_score, 20)} <b>{data.average_score}</b></div>
      <p>{commentText}</p>

      <div className={styles.criterias}>
        {data.scores.map((item) => (
          <span className={styles.criteria} key={item.criteria_id}>
            {item.criteria_name}{' '}
            <span className={styles.grade}>
              {renderStars(item.score, 20)} <b>{item.score}</b>
            </span>
          </span>
        ))}
      </div>

      {data.comment.length > 100 && (
        <span onClick={() => setFullMode(!fullMode)}>
          {fullMode ? 'Скрыть' : 'Показать полностью'}
        </span>
      )}

      <div>
        <div>
          <AiFillLike
            size={30}
            color={data.liked_by_me ? '#7b2b2a' : 'grey'}
            onClick={createVoteHandler('like')}
          />
          <span>{data.likes}</span>
        </div>
        <div>
          <AiFillDislike
            size={30}
            color={data.disliked_by_me ? '#7b2b2a' : 'grey'}
            onClick={createVoteHandler('dislike')}
          />
          <span>{data.dislikes}</span>
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = ({ auth, reviews }) => ({
  data: reviews.current.data,
  pageCount: reviews.current.pageCount,
  loading: reviews.loading,
  isTeacher: auth.isTeacher,
});

export default connect(mapStateToProps, { getCurrent, createVote })(Current);
